import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

export type StartQontoOAuthResponse = {
  authorizationUrl: string;
  state: string;
};

export function startQontoOAuthErrorMessage(err: unknown): string {
  if (err && typeof err === 'object' && 'message' in err) {
    const message = String((err as { message: string }).message);
    if (message && !message.startsWith('Firebase')) {
      return message;
    }
  }
  if (err && typeof err === 'object' && 'code' in err) {
    const code = String((err as { code: string }).code);
    if (code === 'functions/unauthenticated') {
      return 'Sign in to connect Qonto.';
    }
    if (code === 'functions/unavailable') {
      return 'Connection service is temporarily unavailable. Try again.';
    }
    if (code === 'functions/internal' || code === 'functions/deadline-exceeded') {
      return 'Could not start Qonto authorization. Try again.';
    }
  }
  return err instanceof Error ? err.message : 'Could not start Qonto authorization.';
}

export async function startQontoOAuth(): Promise<StartQontoOAuthResponse> {
  const fn = httpsCallable<void, StartQontoOAuthResponse>(functions, 'startQontoOAuth');
  const result = await fn();
  const authorizationUrl =
    typeof result.data.authorizationUrl === 'string' ? result.data.authorizationUrl.trim() : '';
  if (!authorizationUrl) {
    throw new Error('Missing authorization URL from server.');
  }
  const state = typeof result.data.state === 'string' ? result.data.state : '';
  return { authorizationUrl, state };
}
